import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Label, Alert } from "adminlte-2-react";
import Multiselect from "multiselect-react-dropdown";
import controller from "./duck";
import controllerServicios from "./../servicios/duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "./../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
// import "react-time-picker-input/dist/components/TimeInput.css"
import moment from "moment";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

function RenderDia({
  diasSeleccionados,
  handleDias,
  deleteRango,
  inicio,
  setInicio,
  fin,
  setFin,
  handleRangos,
  dia,
  nombreDia,
}) {
  return (
    <Col lg="12">
      <div
        style={{
          marginTop: 10,
        }}
      />
      <Col lg="2">
        <Button
          type={
            diasSeleccionados[dia].habilitado === true ? "success" : "default"
          }
          text={nombreDia}
          onClick={() =>
            handleDias(
              dia,
              diasSeleccionados[dia].habilitado === true
                ? { habilitado: false, rangos: [] }
                : { habilitado: true, rangos: [] }
            )
          }
        />
      </Col>

      <Col lg="10">
        {diasSeleccionados[dia].habilitado === true ? (
          <div>
            <Col lg="10">
              {diasSeleccionados[dia].rangos.map((row, index) => (
                <div key={index}>
                  <Col lg="4">
                    <text>
                      <strong>Desde: {row.inicio}</strong>
                    </text>
                  </Col>
                  <Col lg="4">
                    <text>
                      <strong>Hasta: {row.fin}</strong>
                    </text>
                  </Col>
                  <Col lg="4" style={{ paddingBottom: 20 }}>
                    <Button
                      type="danger"
                      text="Eliminar intervalo"
                      onClick={() => deleteRango(dia, index)}
                    />
                  </Col>
                </div>
              ))}
            </Col>
            <Col lg="12" style={{ marginTop: 20 }}>
              <Col lg="4">
                <text>
                  <strong>Desde</strong>
                </text>
                <TimeInput value={inicio} onChange={setInicio} />
              </Col>

              <Col lg="4">
                <text>
                  <strong>Hasta</strong>
                </text>
                <TimeInput value={fin} onChange={setFin} />
              </Col>
              <Col lg="4" style={{ marginTop: 25 }}>
                <Button
                  type="primary"
                  text="Añadir intervalo"
                  onClick={() => handleRangos(dia, inicio, fin)}
                />
              </Col>
            </Col>
          </div>
        ) : (
          <Col lg="6" mdOffset="3">
          <div style={{ marginTop: 5 }}>
            <text>Cerrado</text>
          </div>
          </Col>
        )}
      </Col>
      <hr
        className="customSeparator"
        // style={{
        //   marginTop:50,
        //     color: 'gray',
        //     backgroundColor: 'gray',
        //     height: 1,
        //     width:'100%',
        // }}
      />
    </Col>
  );
}

function CargarHorario({ history, match }) {
  const dispatch = useDispatch();
  const modelProfesionales = useSelector(
    (state) => state.profesionalesForSelect
  );
  const modelCargarHorario = useSelector((state) => state.cargarHorario);
  const modelServicios = useSelector(
    (state) => state.opcionesServicioByProfesional
  );

  const [profesionalesOptions, setProfesionalesOptions] = useState([]);
  const [profesional, setProfesional] = useState(null);
  const [diasSeleccionados, setDiasSeleccionados] = useState({
    1: {
      habilitado: false,
      rangos: [],
    },
    2: {
      habilitado: false,
      rangos: [],
    },
    3: {
      habilitado: false,
      rangos: [],
    },
    4: {
      habilitado: false,
      rangos: [],
    },
    5: {
      habilitado: false,
      rangos: [],
    },
    6: {
      habilitado: false,
      rangos: [],
    },
    7: {
      habilitado: false,
      rangos: [],
    },
  });
  // const [dia, setDia] = useState(1);
  const [servicioOptions, setServicioOptions] = useState([]);
  const [servicioSelected, setServicioSelected] = useState([]);

  const [inicioLunes, setInicioLunes] = useState("07:00");
  const [finLunes, setFinLunes] = useState("21:00");

  const [inicioMartes, setInicioMartes] = useState("07:00");
  const [finMartes, setFinMartes] = useState("21:00");

  const [inicioMiercoles, setInicioMiercoles] = useState("07:00");
  const [finMiercoles, setFinMiercoles] = useState("21:00");

  const [inicioJueves, setInicioJueves] = useState("07:00");
  const [finJueves, setFinJueves] = useState("21:00");

  const [inicioViernes, setInicioViernes] = useState("07:00");
  const [finViernes, setFinViernes] = useState("21:00");

  const [inicioSabado, setInicioSabado] = useState("07:00");
  const [finSabado, setFinSabado] = useState("21:00");

  const [inicioDomingo, setInicioDomingo] = useState("07:00");
  const [finDomingo, setFinDomingo] = useState("21:00");

  useEffect(() => {
    const data = modelProfesionales?.data?.data?.data;
    const error = modelProfesionales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerServicios.duckProfesionalesForSelect.actions.clear());
    }
    if (data) {
      setProfesionalesOptions(data);

      dispatch(controllerServicios.duckProfesionalesForSelect.actions.clear());
    }
  }, [modelProfesionales]);

  useEffect(() => {
    const data = modelServicios?.data?.data?.data;
    const error = modelServicios?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckServicios.actions.clear());
    }
    if (data) {
      setServicioOptions(data);
      dispatch(controller.duckServicios.actions.clear());
    }
  }, [modelServicios]);

  useEffect(() => {
    dispatch(
      controllerServicios.profesionalesForSelectThunk(match.params.localId)
    );
  }, []);

  useEffect(() => {
    const data = modelCargarHorario?.data?.data;
    const error = modelCargarHorario?.error?.response?.data?.mensaje;
    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      history.push(`/horariosList/${match.params.localId}`);
      dispatch(controller.duck.actions.clear());
    }
  }, [modelCargarHorario]);

  function selectProfesional(value) {
    setProfesional(value);
    setServicioSelected([]);
    dispatch(controller.opcionesServiciosByProfesionalThunk(value));
  }

  function submit() {
    const diasArray = Object.values(diasSeleccionados);
    if (
      servicioSelected.length === 0 ||
      !profesional ||
      !match.params.localId
    ) {
      alert("Por favor complete todos los campos");
      return;
    }
    let hayIntervalo = false;
    diasArray.forEach((row)=>{
   
      if(row.habilitado && row.rangos.length>0){
        hayIntervalo = true;
      }
    })
    if (
      !hayIntervalo
    ) {
      alert("Intervalos no agregados");
      return;
    }
    let data = {
      diasArray,
      servicios: servicioSelected,
      profesionalId: profesional,
      localId: match.params.localId,
    };
    dispatch(controller.cargarHorarioThunk(data));
  }

  function handleDias(dia, value) {
    let newDias = {
      1: diasSeleccionados[1],
      2: diasSeleccionados[2],
      3: diasSeleccionados[3],
      4: diasSeleccionados[4],
      5: diasSeleccionados[5],
      6: diasSeleccionados[6],
      7: diasSeleccionados[7],
    };
    newDias[dia] = value;
    setDiasSeleccionados(newDias);
  }

  function handleRangos(dia, inicio, fin) {
    if (fin <= inicio) {
      return alert("El final del rango es menor o igual al inicio");
    }
    let newDias = {
      1: diasSeleccionados[1],
      2: diasSeleccionados[2],
      3: diasSeleccionados[3],
      4: diasSeleccionados[4],
      5: diasSeleccionados[5],
      6: diasSeleccionados[6],
      7: diasSeleccionados[7],
    };
    const nuevoRango = {
      inicio,
      fin,
    };
    const coincide = newDias[dia].rangos.filter(
      (fila) =>
        (inicio >= fila.inicio && inicio < fila.fin) ||
        (fin > fila.inicio && fin <= fila.fin) ||
        (inicio <= fila.inicio && fin >= fila.fin) ||
        (inicio <= fila.inicio && fin >= fila.fin)
    );

    if (coincide.length > 0) {
      return alert("Rango coincide con uno previamente cargado");
    }

    newDias[dia].rangos.push(nuevoRango);
    setDiasSeleccionados(newDias);
  }

  function deleteRango(dia, index) {
    let newDias = {
      1: diasSeleccionados[1],
      2: diasSeleccionados[2],
      3: diasSeleccionados[3],
      4: diasSeleccionados[4],
      5: diasSeleccionados[5],
      6: diasSeleccionados[6],
      7: diasSeleccionados[7],
    };

    newDias[dia].rangos.splice(index, 1);
    setDiasSeleccionados(newDias);
  }
  return (
    <Content title="Nuevo horario" browserTitle="Nuevo horario" show={false}>
      <Row>
        <Col lg="8" mdOffset="2">
          <Box
            title="Nuevo horario"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(`/horariosList/${match.params.localId}`);
                  }}
                />
                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelCargarHorario.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelCargarHorario.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
                        <Col md="12">
              <Alert type="warning" title="Aviso">
                <p>
                  Debe añadir intervalos para que los registros queden guardados.
                </p>
              </Alert>
            </Col>
            <ReferenciaObligatorios />

            <SelectInput
              value={profesional}
              setValue={selectProfesional}
              label={<Etiqueta texto="Profesional" obligatorio={true} />}
              options={profesionalesOptions}
            />

            <div style={{ marginBottom: 10 }}>
              <label>
                <Etiqueta texto="Servicios" obligatorio={true} />
              </label>
              <Multiselect
                hidePlaceholder={true}
                options={servicioOptions}
                selectedValues={servicioSelected}
                onSelect={(selectedList, selectedItem) => {
                  setServicioSelected([...servicioSelected, selectedItem]);
                }}
                onRemove={(selectedList, removedItem) => {
                  setServicioSelected(selectedList);
                }}
                displayValue="label"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <Col lg="12" style={{ marginLeft: -10 }}>
                <text>
                  <strong>Dias</strong>
                </text>
              </Col>

              <RenderDia
                dia={1}
                nombreDia="Lunes"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioLunes}
                setInicio={setInicioLunes}
                fin={finLunes}
                setFin={setFinLunes}
                handleRangos={handleRangos}
              />

              <RenderDia
                dia={2}
                nombreDia="Martes"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioMartes}
                setInicio={setInicioMartes}
                fin={finMartes}
                setFin={setFinMartes}
                handleRangos={handleRangos}
              />

              <RenderDia
                dia={3}
                nombreDia="Miercoles"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioMiercoles}
                setInicio={setInicioMiercoles}
                fin={finMiercoles}
                setFin={setFinMiercoles}
                handleRangos={handleRangos}
              />

              <RenderDia
                dia={4}
                nombreDia="Jueves"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioJueves}
                setInicio={setInicioJueves}
                fin={finJueves}
                setFin={setFinJueves}
                handleRangos={handleRangos}
              />

              <RenderDia
                dia={5}
                nombreDia="Viernes"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioViernes}
                setInicio={setInicioViernes}
                fin={finViernes}
                setFin={setFinViernes}
                handleRangos={handleRangos}
              />

              <RenderDia
                dia={6}
                nombreDia="Sabado"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioSabado}
                setInicio={setInicioSabado}
                fin={finSabado}
                setFin={setFinSabado}
                handleRangos={handleRangos}
              />

              <RenderDia
                dia={7}
                nombreDia="Domingo"
                diasSeleccionados={diasSeleccionados}
                handleDias={handleDias}
                deleteRango={deleteRango}
                inicio={inicioDomingo}
                setInicio={setInicioDomingo}
                fin={finDomingo}
                setFin={setFinDomingo}
                handleRangos={handleRangos}
              />
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default CargarHorario;
